const hairLength = [
  { label: "Bald", value: "Bald" },
  { label: "Shaved", value: "Shaved" },
  { label: "Medium", value: "Medium" },
  { label: "Long", value: "Long" },
  { label: "Changes frequently", value: "Changes frequently" },
];

export default hairLength;
